import { render, staticRenderFns } from "./KlarnaCredentials.vue?vue&type=template&id=ad8117c8&scoped=true"
import script from "./KlarnaCredentials.vue?vue&type=script&lang=js"
export * from "./KlarnaCredentials.vue?vue&type=script&lang=js"
import style0 from "./KlarnaCredentials.vue?vue&type=style&index=0&id=ad8117c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8117c8",
  null
  
)

export default component.exports